import React, { useEffect } from 'react';

import { Container, Typography, styled } from '@mui/material';

import { setSeoMeta } from './seo';

const Paragraph = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  '&:last-of-type': {
    marginBottom: 0,
  },
}));

const SITE = 'ru.lett.cc';

export default function PublicOfferWeb() {
  useEffect(() => {
    setSeoMeta({
      title: 'Публичная оферта — Lett Премиум',
      description:
        'Публичная оферта на предоставление права использования функционала Lett Премиум на сайте ru.lett.cc.',
    });
  }, []);

  return (
    <Container maxWidth="md" sx={{ padding: 3 }}>
      <Paragraph>
        Самозанятый гражданин Российской Федерации Мошков Сергей Александрович, ИНН 525903882831,
        именуемый в дальнейшем «Исполнитель», настоящим предлагает любому дееспособному физическому
        лицу, именуемому в дальнейшем «Пользователь», заключить договор на условиях настоящей
        публичной оферты.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        1. Общие положения
      </Paragraph>
      <Paragraph>
        1.1. Настоящий документ является публичной офертой в соответствии со статьей 437
        Гражданского кодекса РФ.
      </Paragraph>
      <Paragraph>
        1.2. Акцептом настоящей оферты является совершение Пользователем оплаты доступа к
        функционалу Lett Премиум на сайте {SITE}.
      </Paragraph>
      <Paragraph>1.3. С момента акцепта договор считается заключенным.</Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        2. Предмет договора
      </Paragraph>
      <Paragraph>
        2.1. Исполнитель предоставляет Пользователю за плату право использования функционала Lett
        Премиум на условиях простой (неисключительной) лицензии на ограниченный срок.
      </Paragraph>
      <Paragraph>
        2.2. Право использования предоставляется в отношении учетной записи Пользователя,
        авторизованной через сторонние сервисы (Google, Apple).
      </Paragraph>
      <Paragraph>
        2.3. Срок предоставления права использования указывается на сайте {SITE} при оформлении
        покупки.
      </Paragraph>
      <Paragraph>
        2.4. Пользователю не передаются исключительные права на приложение Lett и его элементы.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        3. Порядок оплаты
      </Paragraph>
      <Paragraph>3.1. Стоимость доступа указывается на сайте {SITE}.</Paragraph>
      <Paragraph>3.2. Оплата производится через сторонние платежные системы.</Paragraph>
      <Paragraph>
        3.3. Исполнитель не является платежным агентом и не несет ответственности за работу платежных
        систем.
      </Paragraph>
      <Paragraph>
        3.4. Пользователь самостоятельно несет ответственность за корректность совершения платежа.
      </Paragraph>
      <Paragraph>
        3.5. Совершая оплату, Пользователь подтверждает, что право использования функционала Lett
        Премиум предоставляется автоматически сразу после успешной оплаты.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        4. Особенности использования
      </Paragraph>
      <Paragraph>
        4.1. Приложение Lett распространяется через сторонние платформы (включая App Store и Google
        Play), а также может использоваться после покупки доступа на сайте.
      </Paragraph>
      <Paragraph>
        4.2. Исполнитель не контролирует и не несет ответственности за работу App Store, Google Play и
        иных сторонних сервисов.
      </Paragraph>
      <Paragraph>
        4.3. В случае если Пользователь приобрел доступ одновременно через сайт и через App Store /
        Google Play, Исполнитель не обязан компенсировать такие расходы.
      </Paragraph>
      <Paragraph>
        4.4. Пользователь использует приложение на своем устройстве и самостоятельно обеспечивает
        техническую возможность его использования.
      </Paragraph>
      <Paragraph>
        4.5. Все фото и видео обрабатываются локально на устройстве Пользователя. Исполнитель не
        хранит и не обрабатывает такие данные на своих серверах.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        5. Отказ от гарантий
      </Paragraph>
      <Paragraph>5.1. Приложение и доступ к нему предоставляются «как есть» (as is).</Paragraph>
      <Paragraph>5.2. Исполнитель не гарантирует:</Paragraph>
      <Paragraph component="div">
        <ul>
          <li>бесперебойную работу приложения;</li>
          <li>отсутствие ошибок;</li>
          <li>соответствие приложения ожиданиям Пользователя;</li>
          <li>достижение каких-либо результатов при использовании.</li>
        </ul>
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        6. Ограничение ответственности
      </Paragraph>
      <Paragraph>6.1. Исполнитель не несет ответственности за:</Paragraph>
      <Paragraph component="div">
        <ul>
          <li>сбои в работе интернета;</li>
          <li>сбои устройств Пользователя;</li>
          <li>действия третьих лиц;</li>
          <li>
            работу сторонних сервисов, включая App Store, Google Play, Google Sign-In, Apple Sign-In
            и платежные системы;
          </li>
          <li>невозможность использования приложения по причинам, не зависящим от Исполнителя.</li>
        </ul>
      </Paragraph>
      <Paragraph>
        6.2. Исполнитель не несет ответственности за временную недоступность приложения,
        обусловленную техническими работами, сбоями инфраструктуры или действиями третьих лиц.
      </Paragraph>
      <Paragraph>
        6.3. Исполнитель не возмещает Пользователю косвенные убытки, упущенную выгоду,
        нематериальный вред ожиданиям Пользователя, а также иные последствия, возникшие вследствие
        использования или невозможности использования приложения, за исключением случаев, когда такая
        ответственность прямо предусмотрена законодательством Российской Федерации.
      </Paragraph>
      <Paragraph>
        6.4. Максимальная ответственность Исполнителя при любых обстоятельствах ограничивается суммой
        оплаты, фактически полученной от Пользователя за соответствующий оплаченный период доступа, в
        пределах, допускаемых законодательством Российской Федерации.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        7. Отказ от покупки и возврат средств
      </Paragraph>
      <Paragraph>
        7.1. Пользователь вправе обратиться с заявлением об отказе от покупки и возврате денежных
        средств до момента автоматической активации права использования функционала Lett Премиум для
        своей учетной записи.
      </Paragraph>
      <Paragraph>
        7.2. Моментом предоставления права использования считается автоматическая активация доступа к
        Lett Премиум для учетной записи Пользователя после успешной оплаты.
      </Paragraph>
      <Paragraph>
        7.3. После активации доступа право использования считается предоставленным в полном объеме для
        соответствующего оплаченного периода. Само по себе неиспользование Пользователем приложения,
        удаление приложения с устройства, выход из учетной записи или отсутствие необходимости в
        дальнейшем использовании не являются основанием для возврата денежных средств.
      </Paragraph>
      <Paragraph>
        7.4. В случаях, когда возврат денежных средств подлежит осуществлению в силу обязательных
        требований законодательства Российской Федерации, возврат производится в порядке,
        предусмотренном такими требованиями.
      </Paragraph>
      <Paragraph>
        7.5. Для рассмотрения обращения Пользователь направляет заявление на электронную почту
        lett.posts@gmail.com с указанием адреса электронной почты учетной записи и информации о
        платеже, достаточной для идентификации оплаты.
      </Paragraph>
      <Paragraph>
        7.6. Обращение рассматривается Исполнителем в течение 5 (пяти) рабочих дней с момента его
        получения.
      </Paragraph>
      <Paragraph>
        7.7. В случае принятия решения о возврате денежные средства возвращаются Пользователю тем же
        способом оплаты в течение 10 (десяти) рабочих дней с момента принятия соответствующего
        решения, если иной срок не установлен правилами соответствующей платежной системы или банка.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        8. Права Исполнителя
      </Paragraph>
      <Paragraph>8.1. Исполнитель вправе в любое время:</Paragraph>
      <Paragraph component="div">
        <ul>
          <li>изменять функционал приложения;</li>
          <li>приостанавливать или прекращать работу сервиса полностью или частично;</li>
          <li>изменять стоимость доступа;</li>
          <li>ограничивать доступ Пользователя в случае нарушения условий.</li>
        </ul>
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        9. Персональные данные
      </Paragraph>
      <Paragraph>
        9.1. Обработка персональных данных Пользователя осуществляется в соответствии с Политикой
        обработки персональных данных, размещенной на сайте {SITE}.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        10. Заключительные положения
      </Paragraph>
      <Paragraph>10.1. Исполнитель вправе изменять условия оферты без уведомления.</Paragraph>
      <Paragraph>10.2. Новая редакция вступает в силу с момента публикации на сайте {SITE}.</Paragraph>
      <Paragraph>10.3. К отношениям сторон применяется законодательство Российской Федерации.</Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        11. Реквизиты Исполнителя
      </Paragraph>
      <Paragraph>
        Самозанятый: Мошков Сергей Александрович
        <br />
        Город: Нижний Новгород
        <br />
        ИНН: 525903882831
        <br />
        Email: lett.posts@gmail.com
      </Paragraph>
    </Container>
  );
}
